

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    // details element ko find kar raha hai jo modal ke content ko contain karta hai
    this.detailsContainer = this.querySelector('details');

    // summary element ko find kar raha hai jo modal open/close ka trigger hai
    this.summaryToggle = this.querySelector('summary');

    // Jab modal open ho aur user "Escape" button dabaye, to modal close ho jaye
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());

    // Summary pe click karne pe onSummaryClick function chalega
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    // Close button ko find kar raha hai aur uspe click event laga raha hai jo modal ko close karega
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    // Summary element ko ek accessible button banane ke liye 'role' attribute add kar raha hai
    this.summaryToggle.setAttribute('role', 'button');
  }

  // Check karega ke modal open hai ya nahi
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  // Jab summary element pe click ho to modal open ya close karega
  onSummaryClick(event) {
    event.preventDefault(); // Default summary behavior rok raha hai
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  // Modal ke bahar click hone pe modal close ho jaye
  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  // Modal ko open karne ka function
  open(event) {
    // Body click event ko handle karne ke liye function set kar raha hai
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    // Modal open kar raha hai
    event.target.closest('details').setAttribute('open', true);

    // Body pe click event add kar raha hai taake bahar click hone pe modal close ho
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Scrolling disable kar raha hai jab modal open ho
    document.body.classList.add('overflow-hidden');

    // Modal ke andar focus trap kar raha hai taake accessibility improve ho
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  // Modal ko close karne ka function
  close(focusToggle = true) {
    // Focus trap hatane ke liye removeTrapFocus function call kar raha hai
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    // Modal close kar raha hai
    this.detailsContainer.removeAttribute('open');

    // Body se click event remove kar raha hai
    document.body.removeEventListener('click', this.onBodyClickEvent);

    // Scrolling enable kar raha hai jab modal band ho
    document.body.classList.remove('overflow-hidden');
  }
}

// Custom HTML element 'details-modal' define kar raha hai taake isko HTML me as a tag use kiya ja sake
customElements.define('details-modal', DetailsModal);
